import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { PsychosocialFormGroup } from 'src/app/calvin-emr-shared/models/assessments/psychosocial.model';
import { FormOption } from 'src/app/shared/models/form-option.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-psychosocial-form',
  templateUrl: './psychosocial-form.component.html',
  styleUrls: ['./psychosocial-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    AssessmentRowComponent,
    EmrCheckboxGroupComponent,
    EmrCheckboxComponent,
    EmrInputComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class PsychosocialFormComponent {
  formGroup = input.required<PsychosocialFormGroup>();

  moodOptions = [
    new FormOption('Non-interactive', 'nonInteractive'),
    new FormOption('Elated', 'elated'),
    new FormOption('Tearful', 'tearful'),
    new FormOption('Anxious', 'anxious'),
    new FormOption('Agitated', 'agitated'),
    new FormOption('Withdrawn', 'withdrawn'),
    new FormOption('Flat', 'flat'),
  ];

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

}
